import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { request } from '@/api/index';
import { uploadParams } from '@/api/index';
export function getList(data) {
  return request({
    url: '/api/StructTemplate/Data',
    method: 'get',
    params: data
  });
}
export function getDetail(data) {
  return request({
    url: '/api/StructTemplate/Get',
    method: 'get',
    params: data
  });
}
export function edit(data) {
  return request({
    url: '/api/StructTemplate/Edit',
    method: 'post',
    data: data
  });
}
export function create(data) {
  return request({
    url: '/api/StructTemplate/Create',
    method: 'post',
    data: data
  });
}
export function deleteItem(data) {
  return request({
    url: '/api/StructTemplate/Delete',
    method: 'post',
    data: data
  });
}
export function batchDeleteItem(params) {
  return request({
    url: '/api/StructTemplate/BatchDelete',
    method: 'post',
    params: params
  });
}
export function switchEnable(params) {
  return request({
    url: '/api/StructTemplate/SwitchEnable',
    method: 'post',
    params: params
  });
}
export function importFile(data) {
  return request(_objectSpread(_objectSpread({}, uploadParams), {}, {
    url: '/CPMS/StructTemplate/Import',
    data: data
  }));
}
var getTmp = '/CPMS/StructTemplate/GetTmp';
export { getTmp };